import React from 'react';
import Input from '../../ui/inputs/Input';
import DeleteIconButton from '../../ui/buttons/DeleteIconButton';
import CurrencyInput from '../../ui/inputs/CurrencyInput';
import Select from '../../ui/selects/Select';

const PatrimonyForm = ({ index, patrimony, onChange, onRemove, canWrite = true }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(index, { ...patrimony, [name]: value });
  };

  return (
    <div className="grid grid-cols-12 gap-8 items-center">
      <div className="col-span-12 md:col-span-4">
        <Input name="name" label="Bem/Ativo" value={patrimony.name || ''} onChange={handleChange} disabled={!canWrite} />
      </div>

      <div className="col-span-12 md:col-span-2">
        <Select
          name="patrimonyType"
          label="Tipo"
          value={patrimony.patrimonyType || ''}
          onChange={handleChange}
          options={[
            { label: 'Financeiro', value: 'financial' },
            { label: 'Imobilizado', value: 'fixed' },
            { label: 'Previdenciário', value: 'previdenciary' },
          ]}
          disabled={!canWrite}
        />
      </div>

      <div className="col-span-12 md:col-span-2">
        <CurrencyInput
          name="value"
          label="Valor (R$)"
          value={patrimony.value ?? ''}
          onChange={handleChange}
          disabled={!canWrite}
        />
      </div>

      <div className="col-span-12 md:col-span-3">
        <Input
          name="description"
          label="Observações"
          value={patrimony.description || ''}
          onChange={handleChange}
          disabled={!canWrite}
        />
      </div>

      {canWrite && (
        <div className="col-span-12 md:col-span-1 flex justify-center items-end h-full">
          <DeleteIconButton onClick={() => onRemove(index)} />
        </div>
      )}
    </div>
  );
};

export default PatrimonyForm;
